import React, { useState, useEffect, useRef } from "react";

//ANT DESIGN
import {
  Layout,
  ConfigProvider,
  Input,
  Row,
  Typography,
  Col,
  Card,
  Table,
  Spin,
  Select,
  Button,
} from "antd";

import { useNavigate } from "react-router-dom";
import MainLayout from "../../../components/layouts/MainLayout";
import { BOM } from "../../../services/definedMethod";
import cnt from "../../../services/definedConstant";
import { connect, useDispatch } from "react-redux";
import TopContent from "../../../components/layouts/TopContent";
import { apiConfig, labelConfig, staticConfig } from "./productMix.config";

import { rightAction } from "../../../redux/actions";
import DownloadTableButtons from "../../../components/DownloadTableButtons";

//global distructures
const { Text } = Typography;

const columns = [
  {
    title: labelConfig.productMixId,
    dataIndex: "key",
  },
  {
    title: labelConfig.productName,
    dataIndex: "productName",
    sorter: (a, b) => a.productName.localeCompare(b.productName),
  },
];

const ManageProductMix = (props) => {
  const navigate = useNavigate();

  //DECLARED VARIABLES
  const {
    userData,
    // onSelectItemAction,
    rightBtn,
    rightAction,
    getGlListAction,
  } = props;
  const { session } = userData;
  const [productMixData, setProductMixData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [originalList, setOriginalList] = useState([]);
  const [tableCount, setTableCount] = useState("10");
  const [selectedRow, setSelectedRow] = useState(null);
  const dispatch = useDispatch();

  function handleSearchInTable(searchKey) {
    searchKey = searchKey.target.value?.toLowerCase();
    // console.log(searchKey);

    if (!searchKey) {
      setProductMixData(originalList);
      return;
    }
    const filterBySearch = originalList.filter(
      (item) =>
        item?.key === parseInt(searchKey) ||
        item?.name?.toLowerCase()?.includes(searchKey.toLowerCase())
    );
    setProductMixData(filterBySearch);
  }
  function selectTableCount(value) {
    setTableCount(value);
  }
  //END METHODS DECLARED

  useEffect(() => {
    //DISABLE ALL RIGHTSIDEBAR ACTION
    {
      BOM.HasPermission("READ_PRODUCTMIX") && getProductMix();
    }
    {
      BOM.HasPermission("CREATE_PRODUCTMIX") && rightAction(cnt.RIGHT_ADD_BTN);
    }
  }, []);

  const getProductMix = () => {
    let body = {
      session,
    };

    BOM.FetchReqAction(body, apiConfig.ProductMix, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
        setIsLoading(false);
      } else {
        const objList = res[0].allowedProducts;
        let tempArray = [];

        objList.forEach((element) => {
          tempArray.push({
            key: element?.id,
            id: element?.id,
            productId: element?.id,
            productName: element.name,
          });
        });

        setProductMixData(tempArray);

        //keep the orginal data to use after gList is modified when change from autorise to disable
        setOriginalList(tempArray);

        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  const getCsvListData = () => {
    return new Promise((resolve, reject) => {
      const params = {
        limit: 1000,
        offset: 0,
      };

      let body = {
        session,
        params,
      };

      BOM.FetchReqAction(body, apiConfig.ProductMix, (err, res) => {
        if (err) {
          reject(err);
        } else {
          const objList = res[0].allowedProducts;
          let tempArray = [];

          objList.forEach((element) => {
            tempArray.push({
              key: element?.id,
              id: element?.id,
              productId: element?.id,
              productName: element.name,
            });
          });

          resolve(tempArray);
        }
      });
    });
  };

  function handleOnView() {
    const { detailBtn } = rightBtn;
    if (detailBtn.toLowerCase() === "primary") {
      navigate("/product-mix-detail", { state: { id: selectedRow.id } });
    } else {
      console.log("Please choose a record from the table to open");
    }
  }

  function handleOnEdit() {
    const { editBtn } = rightBtn;
    if (editBtn.toLowerCase() === "primary") {
      navigate("/edit-product-mix", { state: { id: selectedRow.id } });
    } else {
      console.log("Please choose a record from the table to open");
    }
  }

  function handleOnCreate() {
    const { addBtn } = rightBtn;
    if (addBtn.toLowerCase() === "primary") {
      navigate("/new-product-mix");
    } else {
      console.log("Could not open the link");
    }
  }

  const onSelectItemAction = (selectedRowKeys, objParam) => {
    //HOLD THE OBJECT SELECTED HERE
    setSelectedRow(objParam[0]);
    [
      BOM.HasPermission("READ_PRODUCTMIX") && cnt.RIGHT_DETAIL_BTN,
      BOM.HasPermission("UPDATE_PRODUCTMIX") && cnt.RIGHT_EDIT_BTN,
    ].map((item) => {
      dispatch({
        type: item,
      });
    });
  };

  return (
    <MainLayout
      isEnableRightSidebar={true}
      onView={handleOnView}
      onAdd={handleOnCreate}
      onEdit={handleOnEdit}
    >
      <TopContent
        pageTitle={labelConfig.manageProductMix}
        pageItems={staticConfig.manageBreadcrumbItems}
        tooltipInfo={labelConfig.tooltipInfo}
      />

      {/* RENDER TABLE LIST */}
      <Card
        title={"List of Product Mix"}
        style={{
          boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
          borderRadius: 20,
        }}
      >
        <Spin spinning={isLoading} size="large">
          <Row style={{ marginBottom: 20 }}>
            <div style={{ marginBottom: "auto" }}>
              <Text>Show</Text>
              <Select
                defaultValue={tableCount}
                options={[
                  { value: "5", label: "5" },
                  { value: "10", label: "10" },
                  { value: "25", label: "25" },
                  { value: "50", label: "50" },
                ]}
                onSelect={selectTableCount}
              />
              <Text>Entries</Text>
            </div>

            <div style={{ margin: "0px 50px" }}>
              <Input
                onChange={handleSearchInTable}
                placeholder="Search by ID or Name..."
                style={{
                  width: 400,
                }}
              />
            </div>
            {/* <DownloadTableButtons
              downloadData={productMixData}
              columns={columns}
              fileName={"Product Mix List"}
              onExportClick={getCsvListData}
            /> */}
          </Row>
          <Table
            rowSelection={{
              type: "radio",
              onChange: onSelectItemAction,
            }}
            columns={columns}
            dataSource={productMixData}
            bordered
            pagination={{
              position: "bottomCentre",
              pageSize: tableCount,
            }}
          />
        </Spin>
      </Card>
    </MainLayout>
  );
};
const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = { rightAction };

export default connect(mapStateToProps, mapDispatchToProps)(ManageProductMix);
